<!-- A11Y-350: ajustes de accesibilidad -->
<div
  class="max-size-form"
  [class.max-size-form--empty-notifications]="!notifications?.length"
>
  <button
    type="button"
    class="modal__close"
    (click)="hide.emit()"
    [attr.aria-label]="'Accessibility.aria_close' | translate"
  >
    <span class="ico-close" aria-hidden="true"></span>
  </button>

  <!-- Estado vacío: misma composición que app-info-modal (icono → título → texto → CTA) -->
  <ng-container *ngIf="!notifications?.length">
    <span class="modal__icon ico-info-circled" aria-hidden="true"></span>
    <h2
      *ngIf="head"
      id="notification-modal-title"
      class="modal__title"
      tabindex="-1"
      #modalTitle
    >
      {{ head | translate }}
    </h2>
    <div class="modal__text">
      <p>{{ 'Notifications.empty_notifications' | translate }}</p>
    </div>
    <button
      #emptyStateAction
      type="button"
      class="modal__btn btn--primary modal__btn-primary-focus"
      (click)="hide.emit()"
    >
      {{ 'Generic.ok_button' | translate }}
    </button>
  </ng-container>

  <!-- Listado de notificaciones -->
  <ng-container *ngIf="notifications?.length">
    <h2
      *ngIf="head"
      id="notification-modal-title"
      class="modal__title"
      tabindex="-1"
      #modalTitle
    >
      {{ head | translate }}
    </h2>
    <section class="modal__notifications">
      <button
        type="button"
        class="modal__notifications__item"
        *ngFor="let notification of notifications; let i = index"
        (click)="toggleNotification(i)"
        [attr.aria-label]="
          (notification.title | translate) +
          (notification.text ? (notification.expanded ? ' - Colapsar' : ' - Expandir') : '')
        "
        [attr.aria-expanded]="notification.text ? notification.expanded : null"
      >
        <div
          class="modal__notifications__item__title"
          [ngClass]="{ priority: notification.priority }"
        >
          <div class="modal__notifications__item__title__wrapper">
            <p class="modal__notifications__item__title__text" [title]="notification.title">
              <span
                [ngClass]="notification.priority ? 'ico-alert' : 'ico-info-circled'"
                aria-hidden="true"
              ></span
              >{{ notification.title | translate }}
            </p>
            <span
              class="ico-arrow-2"
              [ngClass]="notification.expanded ? 'arrow--up' : 'arrow--down'"
              *ngIf="notification?.text"
              aria-hidden="true"
            ></span>
          </div>
          <div
            class="modal__notifications__item__info"
            [@expandCollapse]="notification.expanded ? 'expanded' : 'collapsed'"
          >
            <ng-container>
              <app-notification-content
                [notification]="notification"
                [redirect]="redirect"
              ></app-notification-content>
            </ng-container>
          </div>
        </div>
      </button>
    </section>
  </ng-container>
</div>
